import { useEffect } from "react";

export default function SEO({ title, description }) {
  useEffect(() => {
    const full = title ? `${title} · TWORAY Ltd` : "TWORAY | Technology Advisory & Cyber Security";
    document.title = full;
    const setMeta = (name, content, prop = false) => {
      if (!content) return;
      const attr = prop ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    const desc = description || "Independent cyber security advisory and technology consulting for startups and scale-ups. ISO 27001 readiness, governance and resilience. Clarity. Security. Growth.";
    setMeta("description", desc);
    setMeta("og:title", full, true);
    setMeta("og:description", desc, true);
    setMeta("og:type", "website", true);
    setMeta("og:url", window.location.href, true);
    setMeta("og:image", "https://tworay.co.uk/brand/social/tworay-og-navy-1200x630.png", true);

    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", full);
    setMeta("twitter:description", desc);
    setMeta("twitter:image", "https://tworay.co.uk/brand/social/tworay-og-navy-1200x630.png");
  }, [title, description]);
  return null;
}
